export const getSessionId = (): string => {
    let sessionId = sessionStorage.getItem("sessionId");
  
    if (!sessionId) {
      // Generate a new ID on each app open
      sessionId = "session-" + Date.now() + "-" + Math.random().toString(36).substring(2, 10);
      sessionStorage.setItem("sessionId", sessionId);
    }
  
    return sessionId;
};
  